<script>
  import { Question } from "../../models/Question.js";
  import { txt } from "../../i18n/i18n";

  /** @type {Question} */
  export let question;

  function getGradientClass(num, total) {
    const percent = Math.round((num * 100) / total);

    if (!percent || percent < 20) {
      return "";
    }
    if (percent < 40) {
      return "gradient1";
    }
    if (percent < 60) {
      return "gradient2";
    }
    if (percent < 80) {
      return "gradient3";
    }
    return "gradient4";
  }
</script>

<div class="matrix-sum">
  <div class="matrix-sum-row matrix-sum-header" aria-hidden="true">
    <div class="matrix-sum-cell matrix-sum-row-title" />
    <ul>
      <li class="matrix-sum-cell">{txt("Responses")}</li>
      {#each question.alternatives as alternative}
        <li class="matrix-sum-cell">{alternative.text}</li>
      {/each}
    </ul>
  </div>

  {#each question.matrixRows as row, i}
    <div class="matrix-sum-row matrix-sum-question">
      <h4 class="matrix-sum-cell matrix-sum-row-title" id={"lbl_R" + row.matrixRowId}>
        {row.text}
      </h4>
      <ul role="rowgroup" aria-labelledby={"lbl_R" + row.matrixRowId}>
        <li class="matrix-sum-cell">
          <span class="matrix-sum-cell__mobile">{txt("Responses_x", [row.numberOfAnswers])}</span>
          <div class="matrix-sum-cell__desktop">
            <span class="screen-reader">{txt("Responses")}</span>
            <span>{row.numberOfAnswers}</span>
          </div>
        </li>
        {#each row.alternatives as alternative}
          <li class="matrix-sum-cell matrix-sum-cell__desktop {getGradientClass(alternative.numberOfAnswers, row.numberOfAnswers)}">
            <span class="screen-reader">{alternative.text}</span>
            <span>{alternative.numberOfAnswers}</span>
          </li>
          <li class="matrix-sum-cell matrix-sum-cell__mobile matrix-sum-cell-item__mobile">
            <span>{alternative.text}</span>
            <span class={getGradientClass(alternative.numberOfAnswers, row.numberOfAnswers)}>
              <span>{alternative.numberOfAnswers}</span>
            </span>
          </li>
        {/each}
      </ul>
    </div>
  {/each}
</div>
